import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import type { TimeseriesPointV1 } from "@/types/v1";
import { formatTime } from "@/lib/time";
import { fmtNumber } from "@/lib/format";

export function RiskTimeseriesChart({ points }: { points: TimeseriesPointV1[] }) {
  return (
    <div className="h-72">
      <ResponsiveContainer>
        <AreaChart data={points} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="g-low" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%"  stopColor="rgb(var(--accent))" stopOpacity={0.45} />
              <stop offset="95%" stopColor="rgb(var(--accent))" stopOpacity={0.05} />
            </linearGradient>
            <linearGradient id="g-susp" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%"  stopColor="rgb(var(--sev-suspicious))" stopOpacity={0.55} />
              <stop offset="95%" stopColor="rgb(var(--sev-suspicious))" stopOpacity={0.06} />
            </linearGradient>
            <linearGradient id="g-high" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%"  stopColor="rgb(var(--sev-high))" stopOpacity={0.6} />
              <stop offset="95%" stopColor="rgb(var(--sev-high))" stopOpacity={0.08} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="rgb(var(--border))" />
          <XAxis
            dataKey="ts"
            tickFormatter={(v: string) => formatTime(v)}
            stroke="rgb(var(--fg-subtle))"
            tick={{ fontSize: 11 }}
          />
          <YAxis stroke="rgb(var(--fg-subtle))" tick={{ fontSize: 11 }} tickFormatter={(v) => fmtNumber(v)} />
          <Tooltip
            contentStyle={{
              backgroundColor: "rgb(var(--surface-2))",
              border: "1px solid rgb(var(--border))",
              borderRadius: 8,
              fontSize: 12,
              color: "rgb(var(--fg))",
            }}
            labelFormatter={(v: string) => formatTime(v)}
            formatter={(v: number, name: string) => [fmtNumber(v), name]}
          />
          <Area type="monotone" dataKey="total"      name="Total"      stroke="rgb(var(--accent))"          fill="url(#g-low)"  strokeWidth={1.5} />
          <Area type="monotone" dataKey="suspicious" name="Suspicious" stroke="rgb(var(--sev-suspicious))"  fill="url(#g-susp)" strokeWidth={1.5} />
          <Area type="monotone" dataKey="highRisk"   name="High risk"  stroke="rgb(var(--sev-high))"        fill="url(#g-high)" strokeWidth={1.75} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
